<!-- Hosted "Pay invoice by card" page. Layout follows design/prototype/pay.html (same shell as /pay-ach). -->
<div class="hosted-page">
  <div class="hosted">
    <!-- Loading: just the page background and a spinner; the card appears once the invoice is in. -->
    <div class="hosted-loading" *ngIf="loadFlag" role="status" aria-live="polite">
      <img class="hosted-spinner" src="../../../assets/images/loading.svg" alt="" aria-hidden="true">
      <span class="sr-only">Loading invoice</span>
    </div>

    <div class="hosted-card" *ngIf="!loadFlag">
      <ng-container *ngIf="!loadFlag">
        <div class="hosted-card__head">
          <h1 class="hosted-card__title">Invoice from {{ReceievedInvoice.account_name}}</h1>
          <div class="bill-grid">
            <div>
              <p>Billed to {{ReceievedInvoice.customer_name}}</p>
              <p>Invoice #{{ReceievedInvoice.invoice_number}}</p>
            </div>
            <div class="r" *ngIf="ReceievedInvoice.amount_due">
              <p class="due">{{ (ReceievedInvoice.amount_due / 100 | currency:'USD':'symbol':'1.2-2') + ' USD' }} due on</p>
              <p>{{ ReceievedInvoice.payment_due_date ? (ReceievedInvoice.payment_due_date | dateFormat: 'MMM dd, yy') : '--' }}</p>
            </div>
          </div>
        </div>

        <div class="hosted-card__body">
          <!-- Paid -->
          <div class="paid-state" *ngIf="ReceievedInvoice.paid === 1">
            <div class="check_mark">
              <div class="sa-icon sa-success animate">
                <span class="sa-line sa-tip animateSuccessTip"></span>
                <span class="sa-line sa-long animateSuccessLong"></span>
                <div class="sa-placeholder"></div>
                <div class="sa-fix"></div>
              </div>
            </div>
            <span class="paid">Paid</span>
          </div>

          <!-- Pay by card -->
          <ng-container *ngIf="ReceievedInvoice.paid !== 1">
            <h2 class="pay-h">Pay By Card</h2>

            <div class="pay-alerts">
              <payarc-inline-alert *ngIf="failureMessage" variant="bad">{{failureMessage}}</payarc-inline-alert>
            </div>

            <form [formGroup]="manualInvoiceForm" (ngSubmit)="payInvoice()" #manualInvoice novalidate>
              <div class="fld">
                <label for="card_number">Card number</label>
                <div class="card-wrap">
                  <input class="pa-input" id="card_number" name="card_number" type="tel" inputmode="numeric" autocomplete="cc-number"
                         placeholder="•••• •••• •••• ••••" ccNumber appAmountValidator [maxLength]="23" required
                         [class.invalid]="submitted && f.creditCard.invalid"
                         (input)="getCardType($event)"
                         [(ngModel)]="customerCard.card_number" formControlName="creditCard">
                  <payarc-card-mark class="card-img" [width]="38" [brand]="type"></payarc-card-mark>
                </div>
                <ng-container *ngIf="submitted && f.creditCard.invalid">
                  <span class="fld__err" *ngIf="f.creditCard.errors?.required">Card number is required.</span>
                  <span class="fld__err" *ngIf="!f.creditCard.errors?.required && f.creditCard.invalid">Card number is invalid.</span>
                </ng-container>
              </div>

              <div class="fld-2">
                <div class="fld">
                  <label for="expiry">Expiry</label>
                  <input class="pa-input" id="expiry" name="expiry" type="tel" inputmode="numeric" autocomplete="cc-exp" required ccExp
                         placeholder="MM/YYYY"
                         [class.invalid]="submitted && f.expDate.invalid"
                         (input)="onCardDataChange()"
                         [(ngModel)]="customerCard.exp" formControlName="expDate">
                  <ng-container *ngIf="submitted && f.expDate.invalid">
                    <span class="fld__err" *ngIf="f.expDate.errors?.required">Expiry date is required.</span>
                    <span class="fld__err" *ngIf="!f.expDate.errors?.required && f.expDate.invalid">Invalid expiry.</span>
                  </ng-container>
                </div>
                <div class="fld">
                  <label for="cvc">CVV</label>
                  <input class="pa-input" id="cvc" name="cvc" type="text" inputmode="numeric" autocomplete="off"
                         placeholder="•••" appAmountValidator maxLength="4" ccCvc required [required]="cvvoptional === 0"
                         oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                         [class.invalid]="submitted && f.cvc.invalid"
                         (keyup)="checkCvc(customerCard.cvc_check_code)" (input)="onCardDataChange()" (keypress)="numericOnly($event)"
                         [(ngModel)]="customerCard.cvc_check_code" formControlName="cvc">
                  <ng-container *ngIf="submitted && f.cvc.invalid">
                    <span class="fld__err" *ngIf="f.cvc.errors?.required">CVV is required.</span>
                    <span class="fld__err" *ngIf="!f.cvc.errors?.required">Invalid CVV.</span>
                  </ng-container>
                  <span class="fld__err" *ngIf="submitted && !f.cvc.invalid && cvcError === true">Invalid CVV.</span>
                </div>
              </div>

              <div class="fld">
                <label for="address_line1">Address line 1</label>
                <input class="pa-input" id="address_line1" name="street" type="text" maxlength="100" autocomplete="address-line1"
                       [(ngModel)]="customerCard.address_line1" formControlName="address_line1"
                       appPlacesAutocomplete [options]="options" (onAddressChange)="handleAddressChange($event)">
              </div>

              <div class="fld-2">
                <div class="fld">
                  <label for="city">City</label>
                  <input class="pa-input" id="city" name="city" type="text" maxlength="200" autocomplete="address-level2"
                         formControlName="city">
                </div>
                <div class="fld">
                  <label for="state">State / Province</label>
                  <select class="pa-input" id="state" name="state" [(ngModel)]="customerCard.state" formControlName="state">
                    <option value="" disabled hidden></option>
                    <option *ngFor="let state of states" [value]="state.name">{{state.name}}</option>
                  </select>
                </div>
              </div>

              <div class="fld-2">
                <div class="fld">
                  <label for="zip">Zip code</label>
                  <input class="pa-input" id="zip" name="zip" type="text" maxlength="10" inputmode="numeric" autocomplete="postal-code"
                         [class.invalid]="submitted && f.zip.invalid"
                         (keypress)="numericOnly($event)" [(ngModel)]="customerCard.zip" formControlName="zip">
                </div>
                <div class="fld">
                  <label for="country">Country</label>
                  <select class="pa-input" id="country" name="country" [ngModel]="customerCard.country" formControlName="country">
                    <option value="" disabled hidden></option>
                    <option *ngFor="let country of countries" [value]="country.key">{{country.name}}</option>
                  </select>
                </div>
              </div>

              <button type="submit" class="pa-btn pa-btn--primary pay-submit" [disabled]="load">
                Pay Invoice <i *ngIf="load" class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
              </button>
            </form>
          </ng-container>

          <!-- Line items -->
          <div class="lineitems">
            <div class="li-period">
              {{ ReceievedInvoice.period_start ? (ReceievedInvoice.period_start | dateFormat: 'MMM dd, yy') : '--' }}
              –
              {{ ReceievedInvoice.period_end ? (ReceievedInvoice.period_end | dateFormat: 'MMM dd, yy') : '--' }}
            </div>
            <table class="li-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th class="c">Qty</th>
                  <th>Unit price</th>
                  <th class="r">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ReceievedInvoice.plan_name}}</td>
                  <td class="c">{{ReceievedInvoice.quantity > 0 ? ReceievedInvoice.quantity : 1}}</td>
                  <td>{{ ReceievedInvoice.plan_amount != null ? ((ReceievedInvoice.plan_amount / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</td>
                  <td class="r">{{ ReceievedInvoice.plan_amount != null ? ((ReceievedInvoice.plan_amount / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</td>
                </tr>
              </tbody>
            </table>

            <div class="li-totals">
              <div class="row-t">
                <span>Sub Total</span>
                <span>{{ ReceievedInvoice.subtotal != null ? ((ReceievedInvoice.subtotal / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</span>
              </div>
              <div class="row-t" *ngIf="ReceievedInvoice.tax_amount">
                <span>Tax</span>
                <span>{{ ((ReceievedInvoice.tax_amount / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' }}</span>
              </div>
              <div class="row-t">
                <span>Total</span>
                <span>{{ ReceievedInvoice.total != null ? ((ReceievedInvoice.total / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</span>
              </div>
              <div class="row-t">
                <span>Amount Paid</span>
                <span>{{ ReceievedInvoice.amount_paid != null ? ((ReceievedInvoice.amount_paid / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' : '--' }}</span>
              </div>
              <div class="row-t" *ngIf="ReceievedInvoice.discount_amount">
                <span>Discount Amount</span>
                <span>{{ ((ReceievedInvoice.discount_amount / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' }}</span>
              </div>
              <div class="row-t grand" *ngIf="ReceievedInvoice.amount_due">
                <span>Amount Due</span>
                <span>{{ ((ReceievedInvoice.amount_due / 100) | currency:'USD':'symbol':'1.2-2') + ' USD' }}</span>
              </div>
            </div>

            <div class="dl-row">
              <button type="button" class="pa-btn pa-btn--ghost dl-link" (click)="dlInvoice()">Download Invoice</button>
              <button type="button" class="pa-btn pa-btn--ghost dl-link" *ngIf="ReceievedInvoice.paid === 1" (click)="dlreceipt()">Download Receipt</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
